import { LeftSide } from './LeftSide';
import { RightSide } from './RightSide';
import { LayoutProps } from '../LayoutProps';

import styles from './ThreeSideLayout.module.css';

/**
 * Three side layout
 */
export function ThreeSideLayout({ clientID, game, children }: LayoutProps) {
    return (
        <div className={styles.container}>
            <div className={styles.leftSide}>
                <LeftSide />
            </div>
            <div className={styles.gameView}>{children}</div>
            <div className={styles.rightSide}>
                <RightSide game={game} clientID={clientID} />
            </div>
        </div>
    );
}
